import { usePosterReducers } from "@/src_new/shared/redux/store/useGetData";
import React, { useEffect } from "react";
import { FieldValues, FormProvider, SubmitHandler, useForm } from "react-hook-form";
import Button from "./Button";

interface FormLayoutProps<T extends FieldValues> {
  title?: string;
  children: React.ReactNode;
  submitText?: string;
  defaultValues?: any;
  onSubmit?: SubmitHandler<T>;
  height?: string;
  customButtons?: {
    name: string;
    onClick: () => void;
    className?: string;
    variant?: "solid" | "outline";
    size?: "sm" | "md" | "lg";
  }[];
  disabled?: boolean;
}

const FormLayout = <T extends FieldValues>({
  title,
  children,
  submitText = "Submit",
  defaultValues,
  onSubmit,
  height,
  customButtons,
  disabled,
}: FormLayoutProps<T>) => {
  const methods = useForm<T>({
    defaultValues,
  });
  useEffect(() => {
    methods.reset(defaultValues);
  }, [defaultValues, methods]);
  const {
    ui: { formLoading },
  } = usePosterReducers();

  return (
    <FormProvider {...methods}>
      <div className="w-full ">
        <div className="w-full">
          {title && (
            <div className="mb-2">
              <h2 className="text-2xl font-semibold text-gray-800">{title}</h2>
            </div>
          )}

          <form onSubmit={methods.handleSubmit(onSubmit)} className="space-y-5">
            <div className={`overflow-y-auto thin-scrollbar ${height || "max-h-[70vh]"}`}>
              {children}
            </div>

            <div className="flex justify-end gap-1">
              {customButtons?.map((i) => (
                <Button
                  type="button"
                  variant={i?.variant}
                  size={i?.size}
                  className={i?.className}
                  onClick={i?.onClick}
                >
                  {i?.name}
                </Button>
              ))}
              {onSubmit && (
                <button
                  type="submit"
                  disabled={formLoading || disabled}
                  className="
    flex items-center justify-center gap-2
    px-5 py-3 h-fit
    rounded-md
    bg-theme-primary text-theme-text-inverse hover:bg-theme-primary-hover
    text-sm font-medium
    transition-all duration-200
    hover:shadow-md cursor-pointer hover:opacity-80
    active:scale-95
    disabled:opacity-60 disabled:cursor-not-allowed
  "
                >
                  {formLoading && (
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  )}

                  <span>{formLoading ? "Saving..." : submitText}</span>
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </FormProvider>
  );
};

export default FormLayout;
